module.exports = __webpack_public_path__ + "static/media/shop_list.af3ce8a3.svg";